import { Proposal } from '../model/types/ProposalSchema';

// Eventually we will need to have logic in here that checks to see if the vendor for the proposal supports price checks
// Right now we're skipping that because we're in single vendor land, but I wanted to break this out to make it easier to refactor when the time comes
export const isProposalInPriceCheck = (proposals: Proposal[]) => {
    if (!proposals) {
        return false;
    }

    return proposals.some(
        (proposal) => !proposal.sellPrice || proposal.sellPrice === 0,
    );
};
